<div class="fluid formgrid grid" *ngIf="document as doc">
  <div class="field xl:col-2 sm:col-6">
    <label for="RA1" class="do-not-wrap-text">DOCID</label>
    <input id="RA1" type="text" pInputText [value]="doc.DOCID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RB1" class="do-not-wrap-text">DOCTYPE</label>
    <input id="RB1" type="text" pInputText [value]="doc.DOCTYPE" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RC1" class="do-not-wrap-text">DOCDATE</label>
    <input id="RC1" type="text" pInputText [value]="doc.DOCDATE" readonly />
  </div>

  <div class="field xl:col-2 sm:col-6">
    <label for="RI1" class="do-not-wrap-text">DOCNUMBER</label>
    <input id="RI1" type="text" pInputText [value]="doc.DOCNUMBER" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI2" class="do-not-wrap-text">DOCEXPDATE</label>
    <input id="RI2" type="text" pInputText [value]="doc.DOCEXPDATE" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI3" class="do-not-wrap-text">DOCVALDATE</label>
    <input id="RI3" type="text" pInputText [value]="doc.DOCVALDATE" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI4" class="do-not-wrap-text">DOCCLIENTSID</label>
    <input id="RI4" type="text" pInputText [value]="doc.DOCCLIENTSID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI5" class="do-not-wrap-text">DOCPERSONID</label>
    <input id="RI5" type="text" pInputText [value]="doc.DOCPERSONID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI6" class="do-not-wrap-text">DOCCLIDEPID</label>
    <input id="RI6" type="text" pInputText [value]="doc.DOCCLIDEPID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI7" class="do-not-wrap-text">DOCLCOCLIID</label>
    <input id="RI7" type="text" pInputText [value]="doc.DOCLCOCLIID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI8" class="do-not-wrap-text">DOCLCOPERID</label>
    <input id="RI8" type="text" pInputText [value]="doc.DOCLCOPERID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RI9" class="do-not-wrap-text">DOCPCODEPID</label>
    <input id="RI9" type="text" pInputText [value]="doc.DOCPCODEPID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RJ1" class="do-not-wrap-text">DOCPCOCLIID</label>
    <input id="RJ1" type="text" pInputText [value]="doc.DOCPCOCLIID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RJ2" class="do-not-wrap-text">DOCPCOPERID</label>
    <input id="RRJ2" type="text" pInputText [value]="doc.DOCPCOPERID" readonly />
  </div>
  <div class="field xl:col-2 sm:col-6">
    <label for="RJ3" class="do-not-wrap-text">DOCPCODEPID</label>
    <input id="RJ3" type="text" pInputText [value]="doc.DOCPCODEPID" readonly />
  </div>
</div>
